import React from 'react'

export const getColorForIconUrl = (iconUrl) => {
  if (!iconUrl) return '#b068f9' // default

  const match = iconUrl.match(/\/([a-z_]+?)(?:_pinlet|-?\d+)?(?:\.png)?$/i)
  const iconName = match ? match[1] : null

  switch (iconName) {
    case 'restaurant':
    case 'food':
    case 'bar':
    case 'bakery':
    case 'cafe':
      return '#fe8022'
    case 'store':
    case 'shopping':
    case 'shoppingcart':
      return '#0095fe'
    case 'school':
    case 'university':
      return '#e44235'
    case 'health':
    case 'doctor':
    case 'pharmacy':
      return '#e84235'
    case 'hotel':
    case 'lodging':
      return '#f848c7'
    default:
      return '#b068f9'
  }
}

export const getIconElement = (m) => {
  const iconUrl = m.icon_url
  const color = getColorForIconUrl(iconUrl)
  const iconSrc = iconUrl ? `${iconUrl}.png` : 'https://maps.gstatic.com/mapfiles/place_api/icons/v2/generic_pinlet.png'

  return (
    <div
      className="search-results__image-wrap"
      style={{
        backgroundColor: color,
        WebkitMaskImage: `url(${iconSrc})`,
        maskImage: `url(${iconSrc})`,
      }}
      onError={e => { e.currentTarget.style.display = 'none' }}
    />
  )
}
